export default __webpack_public_path__ + "static/media/icon-GetItFast.1d688d58.svg";